export default "__VITE_ASSET___8pYe_7B__"